import jwtDecode from 'jwt-decode'

import { API_ROOT } from '../config'
import { CALL_API } from '../middleware/api'

export const AUTH_LOGIN_REQUEST = 'AUTH_LOGIN_REQUEST'
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS'
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE'

function authLoginRequest() {
  return {
    type: AUTH_LOGIN_REQUEST
  }
}

export function authLoginSuccess(token) {
  const jwt = jwtDecode(token)

  return {
    type: AUTH_LOGIN_SUCCESS,
    data: {
      id: jwt.id,
      fullname: jwt.fullname,
      role: jwt.role,
      type: jwt.type
    }
  }
}

function authLoginFailure(error) {
  return {
    type: AUTH_LOGIN_FAILURE,
    error
  }
}

export function authLogin(details, admin, promoter) {
  return dispatch => {
    dispatch(authLoginRequest())

    const config = {
      method: 'POST',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify(details)
    }

    let route = 'login'

    if(admin){
      route = 'login/admin'
    }else if(promoter){
      route = 'login/promoter'
    }

    return fetch(API_ROOT + route, config)
      .then(response =>
        response.json().then(json => {
          if (!response.ok) {
            return Promise.reject(json)
          }

          localStorage.setItem('token', json.token)

          return dispatch(authLoginSuccess(json.token))
        })
      ).catch(error => dispatch(authLoginFailure(error)))
  }
}

export const AUTH_LOGOUT = 'AUTH_LOGOUT'

export function authLogout() {
  return dispatch => {
    localStorage.removeItem('token')
    dispatch({ type: AUTH_LOGOUT })
  }
}

export const AUTH_PASSWORD_RECOVERY_REQUEST = 'AUTH_PASSWORD_RECOVERY_REQUEST'
export const AUTH_PASSWORD_RECOVERY_SUCCESS = 'AUTH_PASSWORD_RECOVERY_SUCCESS'
export const AUTH_PASSWORD_RECOVERY_FAILURE = 'AUTH_PASSWORD_RECOVERY_FAILURE'

export function passwordRecoveryEmail(props) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `login/passwordrecovery`,
      authenticated: false,
      body: JSON.stringify(props),
      types: [AUTH_PASSWORD_RECOVERY_REQUEST, AUTH_PASSWORD_RECOVERY_SUCCESS,
        AUTH_PASSWORD_RECOVERY_FAILURE]
    }
  }
}

export function passwordRecoveryClientEmail(props) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `login/passwordrecoveryclient`,
      authenticated: false,
      body: JSON.stringify(props),
      types: [AUTH_PASSWORD_RECOVERY_REQUEST, AUTH_PASSWORD_RECOVERY_SUCCESS,
        AUTH_PASSWORD_RECOVERY_FAILURE]
    }
  }
}